export default __webpack_public_path__ + "src/assets/blog.9947a801734e10cde88b100f527c5ad0.svg";